import { render, staticRenderFns } from "./FixedIncomeDurationArea.vue?vue&type=template&id=70c89736&scoped=true&"
import script from "./FixedIncomeDurationArea.vue?vue&type=script&lang=js&"
export * from "./FixedIncomeDurationArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c89736",
  null
  
)

export default component.exports